import './app.css';
import SingleExampleApp from './single_example_app';


function App() {
  return <SingleExampleApp></SingleExampleApp>;
}

export default App;
